module.exports = __webpack_public_path__ + "static/media/inspect.aea1d38d.png";